import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { RuleService } from '@app/shared/services/rule/rule.service';

@Component({
  standalone: false,
  selector: 'sbnb-dialog-add-notification',
  templateUrl: './dialog-add-notification.component.html',
  styleUrls: ['./dialog-add-notification.component.scss'],
})
export class DialogAddNotificationComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    public dialogRef: MatDialogRef<DialogAddNotificationComponent>,
    private ruleService: RuleService,
    private router: Router
  ) { }

  ngOnInit() { }

  dismissModal() {
    this.dialogRef.close();
  }

  createNotificationRule(name: string, event: string, beforeEvent: boolean = false) {
    let payload: any = {
      active: false,
      name,
      event,
      all_properties: true,
      mode: 'offensive',
      team: {
        notify_via: 'email',
        send_ical: false,
        send_me_a_copy: false,
        services: [],
      },
    };

    if (event === 'team:checkin' || event === 'team:checkout') {
      payload.time = '1d';

      if (beforeEvent) {
        payload.time = '-1d';
      }
    }

    this.ruleService.createRuleset(payload).subscribe((res) => {
      if (res.data) {
        this.router.navigate(['/operations/notifications/detail/' + res.data.id]);
        this.dialogRef.close();
      }
    });
  }
}
